import axios, { AxiosResponse } from "axios";
import environment from "../config";
import axiosUtil from "../utils/helpers/axiosUtil";

export async function GetAmitimBranches() {
  try {
    const path = environment.BASE_URL + "General/GetAmitimBranches";
    const res: AxiosResponse<any> = await axios.get(path);
    if (axiosUtil.isSuccess(res)) {
      const { branches, generalBranches } = res.data;
      return { branches, generalBranches };
    }
    return {};
  } catch (err) {
    console.log(err);
  }
}
